import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormDirty } from "go-form/components/FormDirty";
import { adminApi } from "../../../../services/Api/Admin/adminApi";
import { partnerApi } from "../../../../services/Api/Partner/partnerApi";
import { selectPartner } from "../../../../services/partner/selectors";
import { selectUser } from "../../../../services/users/selectors";

interface Props {
	isShown: boolean;
	onHide: () => void;
	loanId: number;
}

interface FormProps {
	email: string;
}

const SendLoanPdfViaEmailModal = ({ isShown, onHide, loanId }: Props) => {
	const { t } = useTranslation();
	const user = useSelector(selectUser);
	const partner = useSelector(selectPartner);

	const form = useForm<FormProps>({
		criteriaMode: "all",
		defaultValues: {
			email: user?.email,
		},
	});
	const {
		formState,
		formState: { errors },
		setError,
		handleSubmit,
		register,
	} = form;
	const { addFlash, addSuccessFlash } = useFlash();
	const [loading, setLoading] = useState(false);

	const onSubmit = handleSubmit(async (data) => {
		setLoading(true);
		try {
			if (partner?.id) {
				await partnerApi.sendLoanViaEmail(partner.id, loanId, { email: data.email });
			} else await adminApi.sendLoanViaEmail(loanId, { email: data.email });
			addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
			onHide();
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal onHide={onHide} show={isShown}>
			<FormDirty isDirty={formState.isDirty} onSubmit={onSubmit}>
				<Modal.Header closeButton>
					<Modal.Title>{t("modules.loan.field.send_loan_via_email.title")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormInput name="email" errors={errors} register={register} label={t("lib:common.word.email")} />
				</Modal.Body>
				<Modal.Footer>
					<ButtonLoading loading={loading} type="submit">
						{t("lib:common.action.send")}
					</ButtonLoading>
					<Button variant="light" onClick={onHide}>
						{t("common.action.cancel", { ns: "lib" })}
					</Button>
				</Modal.Footer>
			</FormDirty>
		</Modal>
	);
};

export default SendLoanPdfViaEmailModal;
